import http from "../http";

export async function approveDecisioning(body) {
  const response = await http.post("/onboarding/decisioning-setup/approval-request/v2", body);
  return response.data;
}

export async function approveP2b(body) {
  const response = await http.post("/onboarding/person-to-business-config-setup/approval-requests", body);
  return response.data;
}

export async function getBusinessSetup(config) {
  const response = await http.get("/onboarding/business-verification-setup", config);

  let data = response.data.details;
  for (var key in data) {
    if (key === "compliance") {
      data[key].availableInFuture = true;
    } else {
      data[key].availableInFuture = false;
    }
  }

  return data;
}

export async function getDecisioningSetup(config) {
  const response = await http.get("/onboarding/decisioning-setup/v3", config);
  return response.data;
}

export async function postDecisioningSetup(body) {
  const response = await http.post("/onboarding/decisioning-setup/v3", body);
  return response.data;
}

export async function getNameMatchingSetup(config) {
  const response = await http.get("/onboarding/person-to-business-config-setup", config);
  return response.data;
}

export async function postNameMatchingSetup(config) {
  const response = await http.post("/onboarding/person-to-business-config-setup", config);
  return response.data;
}

export async function getMatchConfidenceSetup(epId) {
  const config = { params: { epId: epId } };
  const response = await http.get("/onboarding/match-confidence-configuration-setup", config);
  return response.data;
}

export async function postMatchConfidenceSetup(config) {
  const response = await http.post("/onboarding/match-confidence-configuration-setup", config);
  return response.data;
}
